import { render } from "./SubRubros.vue?vue&type=template&id=039e39f9"
import script from "./SubRubros.vue?vue&type=script&lang=js"
export * from "./SubRubros.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__